import styled, { css } from "styled-components";


export const MetaKulHeading = styled.div`
  background: linear-gradient(90.71deg, #73e0a9 0%, #5b68df 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
font-size: 25px;

`;
export const MetaKulHeading1 = styled.div`
  background: linear-gradient(90.71deg, #73e0a9 0%, #5b68df 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
font-size: 25px;


`;